// extracted by mini-css-extract-plugin
export var formContainer = "_kf-0";
export var message = "_kf-1";